// extracted by mini-css-extract-plugin
export default {"mobile-disclaimer":"g__mobile-disclaimer--pTUqI"};